import { Component } from '@theme/component';

export function electionCountdownParts(now = Date.now()) {
  const remaining = Math.max(0, Math.ceil((Date.parse('2026-11-03T10:00:00Z') - now) / 1000));
  return {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
}

class ElectionCountdown extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller = new AbortController();
    this.updateCountdown();
    if (!this.expired) this.timer = setInterval(() => this.updateCountdown(), 1000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.updateCountdown(); }, {signal: this.controller.signal});
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.timer);
    this.controller?.abort();
  }
  updateCountdown() {
    const now = Date.now();
    this.hidden = now < Date.parse('2026-10-23T23:00:00Z') || now >= Date.parse('2026-11-03T10:00:00Z');
    for (const [part, value] of Object.entries(electionCountdownParts(now))) {
      const text = String(value).padStart(2, '0');
      const node = this.querySelector('[data-countdown-part="' + part + '"]');
      if (node && node.textContent !== text) node.textContent = text;
    }
    if (now >= Date.parse('2026-11-03T10:00:00Z') && !this.expired) {
      this.expired = true;
      clearInterval(this.timer);
      this.dispatchEvent(new CustomEvent('election:polls-closed', {bubbles: true}));
    }
  }
}
if (!customElements.get('election-countdown')) customElements.define('election-countdown', ElectionCountdown);
